<template>
  <div class="search-drawer-rooms">
    <div class="form__container">
      <i-form class="form" :label-width="80">
        <i-form-item label="所在階">
          <i-input v-model="search.floor_no" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">階以上</span>
        </i-form-item>
        <i-form-item label="バルコニー">
          <i-input v-model="search.balcony_area" style="width: 80px;" placeholder clearable filterable size="small" />
          ㎡以上
        </i-form-item>

        <i-form-item label="間取り">
          <i-select
            v-model="search.number_of_rooms_from"
            size="small"
            placeholder
            filterable
            clearable
            style="width: 60px;"
          >
            <i-option v-for="item in selNumberOfRooms" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">〜</span>
          <i-select
            v-model="search.number_of_rooms_to"
            size="small"
            placeholder
            filterable
            clearable
            style="width: 60px;"
          >
            <i-option v-for="item in selNumberOfRooms" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>

          <i-checkbox-group v-model="search.mi_floor_plan_cd">
            <i-checkbox :label="1" style="margin-left: 8px;">
              R
            </i-checkbox>
            <i-checkbox :label="2" style="margin-left: 8px;">
              K
            </i-checkbox>
            <i-checkbox :label="3" style="margin-left: 8px;">
              DK
            </i-checkbox>
            <i-checkbox :label="5" style="margin-left: 8px;">
              LK
            </i-checkbox>
            <i-checkbox :label="4" style="margin-left: 8px;">
              LDK
            </i-checkbox>
            <i-checkbox :label="99" style="margin-left: 8px;">
              その他
            </i-checkbox>
          </i-checkbox-group>
        </i-form-item>

        <i-form-item label="専有面積">
          <i-input v-model="search.exclusive_area" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">㎡以上</span>
          <span class="label" style="margin-left: 16px;">DK／LDK</span>
          <i-select v-model="search.room_size" size="small" placeholder filterable clearable style="width: 60px;">
            <i-option v-for="item in selRoomSize" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">畳以上</span>
        </i-form-item>

        <i-form-item label="駐車場">
          <i-checkbox-group v-model="search.parking_exist">
            <i-checkbox v-for="(item, idx) in master.parking_exist" :label="item.cd" :key="idx">
              {{ item.label }}
            </i-checkbox>
          </i-checkbox-group>

          <i-select
            v-model="search.parking_fee_from"
            size="small"
            placeholder
            filterable
            clearable
            style="width: 60px;"
          >
            <i-option v-for="item in selParkingFee" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">万円</span>
          <span class="form__text">〜</span>
          <i-select v-model="search.parking_fee_to" size="small" placeholder filterable clearable style="width: 60px;">
            <i-option v-for="item in selParkingFee" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">万円</span>
        </i-form-item>

        <i-form-item label="部屋設備">
          <template v-for="(item, idx) in roomEquipments">
            <div :key="`roomEquipments${idx}`" class="equipments">
              <span class="equipments__label">
                {{ item.name }}
              </span>
              <div class="equipments__checkboxs">
                <template v-for="(item, idx) in item.checkbox">
                  <i-checkbox :key="`checkbox${idx}`" v-model="search[item.value]" :true-value="1" :false-value="0">
                    {{ item.label }}
                  </i-checkbox>
                </template>
              </div>
            </div>
          </template>
        </i-form-item>
      </i-form>
    </div>
  </div>
</template>

<script>
import { Input, Form, FormItem, Select, Option, CheckboxGroup, Checkbox } from 'view-design'
import RoomEquipments from '@/constants/room_equipments'
export default {
  components: {
    'i-input': Input,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option,
    'i-checkbox-group': CheckboxGroup,
    'i-checkbox': Checkbox,
  },
  data() {
    return {
      selNumberOfRooms: [],
      selRoomSize: [],
      selParkingFee: [],
      roomEquipments: RoomEquipments,
    }
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
  },
  created() {
    // Option用 間取り
    for (let i = 1; i <= 20; i++) this.selNumberOfRooms.push(i)
    // Option用 DK／LDK
    for (let i = 1; i <= 20; i++) this.selRoomSize.push(i)
    // Option用 駐車場
    for (let i = 0; i <= 50; i++) this.selParkingFee.push(i)
  },
}
</script>

<style lang="scss" scoped>
.search-drawer-rooms {
  .form {
    &__container {
      height: calc(100vh - 280px);
      overflow: scroll;
    }
    &__text {
      display: inline-block;
      margin: 0 8px;
    }
  }
  .equipments {
    display: flex;
    align-items: flex-start;
    &__label {
      display: inline-block;
      width: 96px;
      font-weight: bold;
    }
    &__checkboxs {
      display: inline-block;
      flex: 1;
    }
  }
}
</style>
